<template>
  <div
    class="flex justify-center h-10 header-footer-logo relative header-logo-size"
     :style="[customCss]"
  >
    <div class="w-full h-full rounded-t-lg bg-center relative">
      <img :src="logoPath" :alt="altText" srcset="" class="h-full" />
      <a class="absolute text-center inset-0" v-if="isPreview" href="/home"></a>
    </div>
    <a v-if="!isPreview" class="opacity-0  m-auto cursor-pointer absolute w-full h-full bg-grey-transparent
            hover:opacity-100 flex items-center justify-center" @click="openHeaderLogo">
          <contentIcon class="edit-logo-icon"/>
    </a>
    <!-- header logo popup -->
    <gd-modal
    v-if="!isPreview"
      name="header-logo-modal"
      :title="$t('frontend_groovemember_builder_change_logo')"
    >
      <div class="flex flex-col m-10">
        
        <div class="text-grey-600 text-xs font-bold mt-4 mb-2 uppercase">
          {{ $t('frontend_groovemember_builder_header_logo') }}
        </div>

        <image-picker
          class="membership-sidebar-imagepicker"
          v-model="membershipLogos.logo"
          :primary="true"
        ></image-picker>
        <div class="text-grey-600 text-xs font-bold mt-4 mb-2 uppercase">
          {{ $t('frontend_size') }}
          <gd-slider
            class="logo-size-slider"
            :min="10"
            :max="200"
            step="10"
            v-model="membershipLogos.logo_size"
          ></gd-slider>
        </div>
        <div class="w-full flex justify-end mt-8">
          <gd-button primary @click="uploadLogos()">{{
            $t('frontend_save')
          }}</gd-button>
        </div>
      </div>
    </gd-modal>
  </div>
</template>
<script>
// import { mapMutations, mapGetters } from 'vuex';
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
import GdSlider from '@groovepages/gd-ui-kit/components/Slider';
import contentIcon from '../../../../assets/images/icons/round-edit.svg';
export default {
  name: 'Logo',
  data() {
    return {
       membershipLogos: {
        logo: '',
        logo_size: '',
      },
    };
  },
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    logoPath: {
      type: String,
      required: false,
    },
    altText: {
      type: String,
      default: 'Logo',
    },
    logoSize: {},
  },
  components: {
    ImagePicker,
    GdSlider,
    contentIcon
  },
  created() {
     this.membershipLogos.logo = this.logoPath;
    this.membershipLogos.logo_size = this.logoSize
      ? this.logoSize
      : 40;
  },
  methods: {
   // ...mapMutations('membershipBuilder', ['UPDATE_ACTIVE_ELEMENT']),
    uploadLogos() {
      this.$emit('upload-logo', { ...this.membershipLogos });
      this.$root.$emit('modal-close', 'header-logo-modal');
    },
    openHeaderLogo() {
      this.$root.$emit('modal-open', 'header-logo-modal');  
    },
  },
  computed: {
   //...mapGetters('membershipBuilder', ['membershipMasterData']),
   customCss() {
      return {
        '--header-logo-size': this.membershipLogos.logo_size + 'px',
      };
    },
  },
  watch:{
   logoPath(newValue){
     this.membershipLogos.logo = newValue;
    },
    logoSize(newValue){
    this.membershipLogos.logo_size = newValue
    }
  }
};
</script>
<style lang="scss">
.header-logo-size {
  height: var(--header-logo-size);
}

.header-footer-logo{
  display: flex;
  // &:hover{
  //   .edit-logo-inner{
  //   opacity: 100;
  //   }
  // }
  .edit-logo-icon{
    path{
      fill: #fff;
    }
  }
  .membership-sidebar-imagepicker > button{
    background: #f86381;
  }
}
</style>

